import {Box, Flex, Heading, SimpleGrid, Text} from "@chakra-ui/react"
import {Link as RouterLink, Navigate} from "react-router-dom"
import {useTranslation} from "react-i18next"
import {FiScissors, FiUsers} from "react-icons/fi"
import {useAppSelector} from "../hooks/store"
import {isBarberLoggedIn, isCustomerLoggedIn} from "../slices/authSlice"
import {analytics} from "../utils/analytics"
import AuthShell from "../components/Auth/AuthShell"
import ChoiceCard from "../components/Auth/ChoiceCard"
import BackLink from "../components/Auth/BackLink"
import {SEO} from "../components/SEO"

export default function RegisterSelection() {
    const {t} = useTranslation()
    const isBarberLogged = useAppSelector(isBarberLoggedIn)
    const isCustomerLogged = useAppSelector(isCustomerLoggedIn)

    if (isBarberLogged) return <Navigate to="/dashboard"/>
    if (isCustomerLogged) return <Navigate to="/customer/portal"/>

    return (
        <AuthShell>
            <SEO
                title="Registrácia — BarberMate"
                description="Zaregistrujte sa na BarberMate ako barber alebo zákazník. Spravujte rezervácie, nájdite barberov v okolí."
                canonical="/register"
            />
            <Box mb="30px">
                <BackLink to="/" label={t('auth.backHome')}/>
                <Heading
                    as="h1"
                    fontFamily="heading"
                    fontWeight={700}
                    fontSize="30px"
                    color="#171717"
                    mt="18px"
                    letterSpacing="-0.01em"
                >
                    {t('auth.registerSelector.title')}
                </Heading>
                <Text fontSize="15.5px" color="#737373" mt="8px">
                    {t('auth.registerSelector.subtitle')}
                </Text>
            </Box>

            <SimpleGrid columns={{base: 1, sm: 2}} gap="16px">
                <ChoiceCard
                    icon={FiScissors}
                    eyebrow={t('auth.choices.barber.eyebrow')}
                    title={t('auth.choices.barber.title')}
                    description={t('auth.choices.barber.registerDescription')}
                    to="/register/barber"
                    accent="blue"
                    ctaLabel={t('auth.continue')}
                    onClick={() => analytics.signupStarted('barber')}
                />
                <ChoiceCard
                    icon={FiUsers}
                    eyebrow={t('auth.choices.customer.eyebrow')}
                    title={t('auth.choices.customer.title')}
                    description={t('auth.choices.customer.registerDescription')}
                    to="/register/customer"
                    accent="red"
                    ctaLabel={t('auth.continue')}
                    onClick={() => analytics.signupStarted('customer')}
                />
            </SimpleGrid>

            <Flex justifyContent="center" mt="26px">
                <Text fontSize="14px" color="#737373">
                    {t('auth.registerSelector.haveAccount')}{' '}
                    <RouterLink to="/login" style={{color: "#0088FF", fontWeight: 600}}>
                        {t('auth.registerSelector.logIn')}
                    </RouterLink>
                </Text>
            </Flex>
        </AuthShell>
    )
}
